import { template as template_cbf2b62a8ad44567a83f6bd31062a5c7 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import type { Model } from '../../routes/render/meta';
const { stringify } = JSON;
export default RouteTemplate(template_cbf2b62a8ad44567a83f6bd31062a5c7(`
  <pre>{{stringify @model null 2}}</pre>
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
